import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessGuard } from 'src/app/SayTS/access-guard';

import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { VerifyEmailComponent } from './auth/verify-email/verify-email.component';
import { RepDashboardComponent } from './dashboard/dashboard.component';
import { ReservationListComponent } from './reservations/reservation-list/reservation-list.component';
import { ReservationFormComponent } from './reservations/reservation-form/reservation-form.component';
import { StationsMapComponent } from './stations-map/stations-map.component';

// Admin components
import { RepAdminGuard } from './guards/admin.guard';
import { AdminDashboardComponent } from './admin/admin-dashboard/admin-dashboard.component';
import { AdminReservationsComponent } from './admin/admin-reservations/admin-reservations.component';
import { AdminLocationsComponent } from './admin/admin-locations/admin-locations.component';
import { AdminLocationComponent } from './admin/admin-location/admin-location.component';
import { AdminUsersComponent } from './admin/admin-users/admin-users.component';
import { AdminUserComponent } from './admin/admin-user/admin-user.component';
import { AdminClientComponent } from './admin/admin-client/admin-client.component';
import { AdminClientsComponent } from './admin/admin-clients/admin-clients.component';
import { AdminSettingsComponent } from './admin/admin-settings/admin-settings.component';
import { AdminVehicleTypeComponent } from './admin/admin-vehicle-type/admin-vehicle-type.component';

const routes: Routes = [
  // Public routes
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'verify-email', component: VerifyEmailComponent },
  { path: 'verify-email/:token', component: VerifyEmailComponent },

  // User routes
  {
    path: 'dashboard',
    component: RepDashboardComponent,
    canActivate: [AccessGuard],
    data: { requiresLogin: true, isMainPage: true }
  },
  {
    path: 'reservations',
    component: ReservationListComponent,
    canActivate: [AccessGuard],
    data: { requiresLogin: true }
  },
  {
    path: 'reservations/new',
    component: ReservationFormComponent,
    canActivate: [AccessGuard],
    data: { requiresLogin: true }
  },
  {
    path: 'stations-map',
    component: StationsMapComponent,
    canActivate: [AccessGuard],
    data: { requiresLogin: true }
  },
  {
    path: 'reservations/:id',
    component: ReservationFormComponent,
    canActivate: [AccessGuard],
    data: { requiresLogin: true }
  },

  // ==================== ADMIN ROUTES ====================

  // Admin Dashboard
  {
    path: 'admin',
    component: AdminDashboardComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true, isMainPage: true }
  },

  // Admin - Rezervace (seznam)
  {
    path: 'admin/reservations',
    component: AdminReservationsComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true }
  },
  // Admin - Rezervace (nová) — sdílený formulář s user-flow, admin features se zapnou podle rights
  {
    path: 'admin/reservations/new',
    component: ReservationFormComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true }
  },
  // Admin - Rezervace (detail) — taky sdílený formulář
  {
    path: 'admin/reservations/:id',
    component: ReservationFormComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true }
  },

  // Admin - Lokace (seznam)
  {
    path: 'admin/locations',
    component: AdminLocationsComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true }
  },
  // Admin - Lokace (detail)
  {
    path: 'admin/locations/new',
    component: AdminLocationComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true }
  },
  {
    path: 'admin/locations/:id_location',
    component: AdminLocationComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true }
  },

  // Admin - Uživatelé (seznam) — jen super admin (r_edit)
  {
    path: 'admin/users',
    component: AdminUsersComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true, superAdmin: true }
  },
  // Admin - Uživatelé (detail) — jen super admin
  {
    path: 'admin/users/new',
    component: AdminUserComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true, superAdmin: true }
  },
  {
    path: 'admin/users/:id_user',
    component: AdminUserComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true, superAdmin: true }
  },

  // Admin - Klienti (seznam) — jen super admin
  {
    path: 'admin/clients',
    component: AdminClientsComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true, superAdmin: true }
  },
  // Admin - Klienti (detail) — jen super admin
  {
    path: 'admin/clients/new',
    component: AdminClientComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true, superAdmin: true }
  },
  {
    path: 'admin/clients/:id_client',
    component: AdminClientComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true, superAdmin: true }
  },

  // Admin - Nastavení (jen super admin)
  {
    path: 'admin/settings',
    component: AdminSettingsComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true, superAdmin: true }
  },
  {
    path: 'admin/settings/vehicle-types/new',
    component: AdminVehicleTypeComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true, superAdmin: true }
  },
  {
    path: 'admin/settings/vehicle-types/:id_vehicle_type',
    component: AdminVehicleTypeComponent,
    canActivate: [RepAdminGuard],
    data: { requiresLogin: true, superAdmin: true }
  },

  // Default routes
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
